<template>
  <div v-if="online" id="cx_letra_video" class="panel-collapse collapse" role="tabpanel"
       aria-labelledby="cx_letra_video">
    <!--se tem video-->
    <div class="container">
      <div class="row">
        <div class="col-md-6" v-if="getCurrent.song_data.video">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe :src="getVideo"
                    sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"></iframe>
          </div>
        </div>
        <!--se nao tem video-->
        <div class="col-md-6" v-if="!getCurrent.song_data.video">
          <div class="sem-video video">
            <i class="fab fa-youtube"></i>
            <hr>
            Nenhum vídeo para esta música
          </div>
        </div>
        <!--se tiver letra, exibe component-->
        <div class="col-md-6 letra">
          <scroll-component v-if="getCurrent.song_data.lyric" :letter="getCurrent.song_data.lyric"></scroll-component>
        </div>
        <!--caso não tenha letra, exibe div abaixo-->
        <semletra v-if="!getCurrent.song_data.lyric"></semletra>
      </div>

    </div>
  </div>
</template>

<script>

  import {mapActions, mapGetters} from 'vuex'
  import ScrollComponent from "./ScrollComponent";
  import Semletra from "./Semletra";

  export default {
    name: "LetraVideo",
    components: {
      ScrollComponent,
      Semletra
    },
    data() {
      return {
        online: this.$store.getters['getCurrentInfo'].online,
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['currentInfo']),
    },
    computed: {
      getCurrent() {
        return this.$store.getters['getCurrentInfo']
      },
      getBuilderInfo() {
        return this.$store.getters['getBuilderInfo']
      },
      getRedeSocial() {
        return this.$store.getters['getRedeSocial']
      },
      getVideo() {
        if (this.getCurrent.song_data.video) {
          return "https://www.youtube.com/embed/" + this.getCurrent.song_data.video + "?rel=0&amp;controls=0&amp;showinfo=0&modestbranding=1&frameborder=0";
        }
      },
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/jqueryplugin/LetraVideo.vue